module.exports = __webpack_public_path__ + "fonts/Merriweather-500-latin-ext20.00e97a0.woff2";